<template>
  <div class="core-value-page">
    <Banner  :bannerUrl="bannerUrl" />
    <div class="container">
      <h2>{{ $t('coreValuePage.coreValue') }}</h2>
      <div class="wish-goal fb">
        <div class="left">{{ $t('coreValuePage.whishGoal') }}</div>
        <div class="right fcc">
          <div>
            <div class="r_title">{{ $t('coreValuePage.whish') }}</div>
            <div class="r_text">{{ $t('coreValuePage.whishText') }}</div>
          </div>
          <div>
            <div class="r_title">{{ $t('coreValuePage.goal') }}</div>
            <div class="r_text">{{ $t('coreValuePage.goalText') }}</div>
          </div>
        </div>
      </div>
      <div class="core-concept fb">
        <div class="left">
          <div class="title">{{ $t('coreValuePage.concept') }}</div>
          <div class="concept-list fs">
            <div class="list-item">
              <span>01</span>
              <div>{{ $t('coreValuePage.concept1') }}</div>
            </div>
            <div class="list-item">
              <span>02</span>
              <div>{{ $t('coreValuePage.concept2') }}</div>
            </div>
            <div class="list-item">
              <span>03</span>
              <div>{{ $t('coreValuePage.concept3') }}</div>
            </div>
            <div class="list-item">
              <span>04</span>
              <div>{{ $t('coreValuePage.concept4') }}</div>
            </div>
          </div>
          <div class="bottom">
            <img :src="bottomBar">
          </div>
        </div>
        <img :src="rightImg" class="r_img">
      </div>
    </div>
  </div>
</template>

<script setup>
import Banner from '@/components/banner'
const bannerUrl = require('@assets/images/banner/banner-core-value.png');
const bottomBar = require('@assets/images/core_value_bottom.png');
const rightImg = require('@assets/images/core_value_right.png');
</script>

<style lang="less" scoped>
.core-value-page {
  padding-bottom: 207px;
  .container {
    h2 {
      font-size: 32px;
      color: #151E2C;
      margin-top: 80px;
      padding-left: 36px;
    }
    .wish-goal {
      background: rgba(246, 246, 246, 0.3);
      padding: 36px 36px;
      margin-top: 27px;
      align-items: flex-start;
      .left {
        flex: 0 0 360px;
        color: #151E2C;
        font-size: 28px;
        height: 191px;
        border-right: solid 1px #E2E2E2;
      }
      .right {
        flex: 1;
        padding-left: 90px;
        align-items: flex-start;
        > div {
          &:last-child {
            margin-top: 91px;
          }
          .r_title {
            color: #151E2C;
            font-size: 20px;
          }
          .r_text {
            font-size: 16px;
            margin-top: 14px;
            color: #4D5563;
          }
        }
      }
    }

    .core-concept {
      margin-top: 90px;
      
      .left {
        width: 653px;
        .title {
          margin-bottom: 96px;
          color: #151E2C;
          font-size: 28px;
        }
        .concept-list {
          flex-wrap: wrap;
          .list-item {
            flex: 0 0 50%;
            flex-wrap: wrap;
            margin-bottom: 81px;
            span {
              color: #BABABA;
              line-height: 46px;
              font-size: 24px;
            }
            div {
              color: #151E2C;
              font-size: 24px;
              line-height: 46px;
            }
          }
        }
        .bottom {
          padding-top: 17px;
        }
      }
      .r_img {
        width: 368px;
        height: 508px;
      }
    }
  }
}
</style>